module.exports = __webpack_public_path__ + "media/images/icons/twotone/usb-78331dbbe4810b297ba0cfa27d2886d9.svg";